import api from '../../api';
import translate from '../../core/tools/translate';
import ShapesAfterSalesInfo from './ShapesAfterSalesInfo';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);
const LayerControls = (name) => require('../../controls').get(name);

class MarkedAreaAfterSalesInfo extends ShapesAfterSalesInfo {
    constructor() {
        const name = 'MarkedAreaAfterSales';

        const options = {
            layer: LayerControls(name).getLayer(),
            label: translate(`Common.${name}`),
            name: name,
            id: 'area-selection',
            context: 'area-selection'
        };

        super(options);

        this.getType = this.getType.bind(this);
    }

    static getInstance() {
        if (!MarkedAreaAfterSalesInfo._instance) {
            MarkedAreaAfterSalesInfo._instance = new MarkedAreaAfterSalesInfo();
        }

        return MarkedAreaAfterSalesInfo._instance;
    }

    _hasActions() { return false; }

    _hasSummary() {
        return true;//isAuthorized(FeaturePermission.INFO_SUMMARY.show);
    }

    getType() {
        return LayerControls(this.options.name).get().scheme();
    }
}

export default MarkedAreaAfterSalesInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/AfterSales/MarkedAreaAfterSalesInfo.js